module.exports = __webpack_public_path__ + "img/Thumbnail_ZWF_Carlos_Fernanda.08c4e28b.jpg";